module.exports = __webpack_public_path__ + "static/img/SmileAnimation_its_mimosaOclock.032d571.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_its_mimosaOclock.gif
// module id = x0la
// module chunks = 0